export const generalFAQ = [
  {
    question: "What is the purpose of this portal?",
    answer: "This portal is designed to streamline FM and FSC compliance audits, improving efficiency and transparency for both auditors and customers.",
  },
  {
    question: "Who should I contact if I have technical issues?",
    answer: "Please use the dedicated Support Channel at https://scsglobalservices.atlassian.net/servicedesk/customer/portal/13 for all technical support. You can also reply to the onboarding email for assistance.",
  },
  {
    question: "What are the system requirements for using the application?",
    answer: "The application is web-based and compatible with modern browsers (Chrome, Firefox, Safari, Edge).",
  },
];


export const auditorFAQ = [
    {
        question: "How do I access my assigned projects?",
        answer: "Your assigned projects are visible on the Auditor Project Dashboard upon logging in.",
    },
    {
        question: "How do I upload documents to a project?",
        answer: "Within the Project Details section, there is an 'Upload Documents' feature. Please use the predefined tags when uploading documents.",
    },
    {
        question: "How do I create a Corrective Action Request (CAR)?",
        answer: "CARs can be created within the Project Details section.",
    },
    {
        question: "How do I generate the CoC Summary Report?",
        answer: "The CoC Summary Report can be generated within the Project Details section.",
    },
    {
        question: "How do I submit a project for technical review?",
        answer: "Once the project is complete, you can submit it for technical review through the project details page.",
    },
    {
        question: "What are the predefined tags for document uploads?",
        answer: "(This will be a list of the tag names used in the application. Please fill in the real tags)",
    },
]

export const customerFAQ = [
    {
        question: "How do I access the Customer Portal?",
        answer: "You can access the Customer Portal using the URL and credentials provided in your onboarding email.",
    },
    {
        question: "What information can I access in the Customer Portal?",
        answer: "You can view the CoC Summary Report and track the progress of your audit.",
    },
    {
        question: "How often is the information in the Customer Portal updated?",
        answer: "The information is updated as the audit progresses. Make sure you refresh your browser as information may update and will not reflect without refreshing the page.",
    },
    {
        question: "How do I know when my audit has been submitted for technical review?",
        answer: "You will be notified via email when your audit has been submitted for technical review.",
    },
]